import React, { Component } from "react";
import { http } from "../modules/api";
import "../../css/AiRpCommonAssets.css";
import "../../css/AiRpDashboard.css";
import SelectBoxV2 from "../modules/common/SelectBoxV2";

import {
  TrendingUp, TrendingDown, Minus, HelpCircle
} from 'lucide-react';

const DATE_OPTIONS = [
  { text: '최근 7일', value: '7' },
  { text: '최근 30일', value: '30' },
  { text: '최근 60일', value: '60' }
];

class AiRpMainDashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedDays: '7',
      installList: [],
    };
  }

  componentDidMount() {
    this.fetchDashboard();
    this.fetchInstallList();
  }

  componentDidUpdate(prevProps, prevState) {
    // 기간이 바뀌면 다시 조회
    if (prevState.selectedDays !== this.state.selectedDays) {
      this.fetchDashboard();
    }
  }

   /**
   * 통계 API 호출
   */
  fetchDashboard = () => {
    const days = parseInt(this.state.selectedDays, 10);

    // 날짜 계산: 오늘 포함 days일
    const { s, e } = this.buildRangeByDays(this.state.selectedDays);
    console.log(`데이터 조회: ${s} ~ ${e} (최근 ${days}일)`);

    http.get("/rest/shop/ai/rp/stats", {
      params: {
        is_group_by_iframe_page_id: true,
        s: s,
        e: e,
      }
    })
    .then(res => {
      // 서버가 Map으로 내려준 구조 그대로 저장
      this.setState({
        dashboard: res.data,
      });
    })
    .catch(err => {
      this.setState({ loading: false, sync: false });
      alert("추천 성과 조회 에러");
    });
  };

  /**
   * 설치 페이미 목록 조회
   */
  fetchInstallList = () => {
    http.get("/rest/shop/ai/rp/installListByPageId", {
      params: {}
    })
    .then(res => {
      // 서버가 Map으로 내려준 구조 그대로 저장
      this.setState({
        installList: res.data.install_list ? res.data.install_list : [],
      });
    })
    .catch(err => {
      this.setState({ loading: false, sync: false });
      alert("설치 페이미 목록 조회 에러");
    });
  };

  /**
   * KST 기준으로 yyyy-mm-dd 만들기 (서버 통계 테이블 stnd_dt 기준)
   */
  toKstYmd = (dateObj) => {
    // dateObj는 JS Date
    // KST로 맞춘 날짜 문자열을 만들기 위해 UTC 기준 보정 (브라우저 로컬이 KST가 아닐 수도 있으니)
    // => "현재 시각 + (KST-UTC) - (localOffset)" 보정
    const tzOffsetMin = dateObj.getTimezoneOffset(); // local offset (분) : KST면 -540
    const kstOffsetMin = -540;
    const diffMin = kstOffsetMin - tzOffsetMin;
    const kstMs = dateObj.getTime() + diffMin * 60 * 1000;
    const d = new Date(kstMs);

    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${y}-${m}-${day}`;
  };

  /**
   * SelectBoxV2가 넘겨주는 형태가 프로젝트마다 다를 수 있는데,
   * 최소한 value 문자열만 잡아내면 됩니다.
   */
  handleDateSelect = (eOrText, eOrValue) => {
    let v = null;

    // 1) e.target.value 형태
    if (eOrValue && eOrValue.target && eOrValue.target.value != null) {
      v = String(eOrValue.target.value);
    } 
    // 2) value 문자열/숫자 직접
    else {
      v = String(eOrValue);
    }

    if (!v) return;
    this.setState({ selectedDays: v });
  };

  /**
   * 최근 N일: s = 오늘 포함 N일 전(=오늘 - (N-1)), e = 오늘
   */
  buildRangeByDays = (daysStr) => {
    const days = parseInt(daysStr, 10) || 7;

    const now = new Date();
    const e = this.toKstYmd(now);

    const start = new Date(now.getTime());
    start.setDate(start.getDate() - (days - 1));
    const s = this.toKstYmd(start);

    return { s, e };
  };

  /**
   * 숫자 포맷
   */
  formatNumber = (v) => {
    if (v == null) return '0';
    const n = Number(v);
    if (isNaN(n)) return String(v);
    return n.toLocaleString('ko-KR');
  };

  /**
   * 원 단위 포맷 (API가 숫자 order_amount를 준다고 가정)
   */
  formatWon = (v) => {
    if (v == null) return '₩ 0';
    const n = Number(v);
    if (isNaN(n)) return String(v);
    return `₩ ${n.toLocaleString('ko-KR')}`;
  };

  /**
   * 증감 상태(up/down/same) 만들기
   * - 예: 매출 증감률 rev_chg_pct 를 사용
   */
  buildChgStatus = (pct) => {
    const n = Number(pct);
    if (!isFinite(n) || isNaN(n)) return { status: 'same', rate: 0 };
    if (n > 0) return { status: 'up', rate: n };
    if (n < 0) return { status: 'down', rate: n };
    return { status: 'same', rate: 0 };
  };

  render() {
    const { selectedDays, dashboard, installList } = this.state;

    const currentOption = DATE_OPTIONS.find(opt => opt.value === selectedDays);
    const selectedText = currentOption ? currentOption.text : '최근 7일';

    // KPI 가공
    const kpi = dashboard && dashboard.kpi ? dashboard.kpi : null;

    const cur_pv = kpi ? kpi.cur_pv : 0;
    const cur_imp = kpi ? kpi.cur_imp : 0;
    const cur_click = kpi ? kpi.cur_click : 0;

    // 주문/매출은 “구매일 기준 + last-click 7일”로 채운 order_cnt/order_amount
    const cur_order = kpi ? kpi.cur_order : 0;
    const cur_rev = kpi ? kpi.cur_rev : 0;

    // CTR/CVR
    const cur_ctr_pct = kpi ? kpi.cur_ctr_pct : 0;
    const cur_cvr_pct = kpi ? kpi.cur_cvr_pct : 0;

    const revChgPct = kpi ? kpi.rev_chg_pct : 0;
    const revChg = this.buildChgStatus(revChgPct);

    const orderStatsDaily = dashboard && dashboard.orderStatsDaily ? dashboard.orderStatsDaily : null;

    const total_order_amount = orderStatsDaily ? orderStatsDaily.total_order_amount ? orderStatsDaily.total_order_amount : 0 : 0;

    // 도달률(= imp/pv)
    const reachPct = (Number(cur_pv) > 0) ? (Number(cur_imp) / Number(cur_pv) * 100) : 0;

    // Funnel
    const funnel = dashboard && dashboard.funnel ? dashboard.funnel : { pv: 0, imp: 0, click_cnt: 0, order_cnt: 0 };
    const f_pv = Number(funnel.pv || 0);
    const f_imp = Number(funnel.imp || 0);
    const f_click = Number(funnel.click_cnt || 0);
    const f_order = Number(funnel.order_cnt || 0);

    // 퍼널 바 차트는 %로 보여주기 위해 pv를 100으로 정규화
    const base = f_pv > 0 ? f_pv : 1;
    const funnelPct = [
      100,
      Math.round((f_imp / base) * 100),
      Math.round((f_click / base) * 100),
      Math.round((f_order / base) * 100)
    ];

    // Slot Table
    const slotTable = dashboard && dashboard.slotTable ? dashboard.slotTable : [];

    const robomd_detail_page_cur_cvr_pct =
      slotTable.find(slot => slot.iframe_page_id === "robomd_ai_detail_page")?.cvr_pct || 0;
    const robomd_main_page_cur_cvr_pct =
      slotTable.find(slot => slot.iframe_page_id === "robomd_ai_main_page")?.cvr_pct || 0;
    const robomd_order_complete_page_cur_cvr_pct =
      slotTable.find(slot => slot.iframe_page_id === "robomd_ai_order_complete_page")?.cvr_pct || 0;
    const robomd_cart_page_cur_cvr_pct =
      slotTable.find(slot => slot.iframe_page_id === "robomd_ai_cart_page")?.cvr_pct || 0;

    const is_robomd_ai_main_page_use = installList.some(
      slot => slot.iframe_page_id === "robomd_ai_main_page"
    );

    const is_robomd_ai_cart_page_use = installList.some(
      slot => slot.iframe_page_id === "robomd_ai_cart_page"
    );

    const is_robomd_ai_order_complete_page_use = installList.some(
      slot => slot.iframe_page_id === "robomd_ai_order_complete_page"
    );

    const is_robomd_ai_detail_page_use = installList.some(
      slot => slot.iframe_page_id === "robomd_ai_detail_page"
    );  

    return (
    <div id='common-page-wrapper'>
      <div className="ai-rp-dashboard">
        <div className="layout-wrapper">
          <main className="main-content">
            <div className="container">
              <div className="page-header">
                <div className="page-header-text">
                  <h1>
                    AI추천 홈
                  </h1>
                  <p>
                    쇼핑몰에 적용된 AI추천 영역의 실시간 데이터를 확인하고 관리하세요.
                  </p>
                </div>
                <div className="header-actions">
                  <SelectBoxV2
                    id="date-filter-select"
                    className="date-filter"
                    width="100%"
                    height="40px"
                    padding="0 36px 0 12px"
                    list={DATE_OPTIONS}
                    optionTexttName="text"
                    optionValuetName="value"
                    selectedValue={selectedDays}
                    selectedText={selectedText}
                    onClickOption={this.handleDateSelect}
                  />
                  <button className="btn-more" onClick={() => { window.open("/shop/ai/rp/dashboard", "_blank") }}>
                    추천성과 상세보기
                    <i className="fa-solid fa-chevron-right" style={{"fontSize": "10px"}}></i>
                  </button>
                </div>
              </div>
              <div className="perf-grid">
                <div className="perf-card">
                  <div className="perf-icon-bg">
                    <i className="fa-regular fa-file-lines"></i>
                  </div>
                  <div className="perf-title">
                    추천 페이지뷰
                    {/* <i className="fa-regular fa-circle-question"></i> */}
                    <div className="tooltip-container">
                      <HelpCircle className="tooltip-icon" size={14} />
                      <div className="tooltip-text">
                        추천 위젯이 설치된 페이지(메인, 상세 등)에<br />소비자가 진입한 총 횟수입니다.
                      </div>
                    </div>
                  </div>
                  <div className="perf-value num-font">
                    {this.formatNumber(cur_pv)}
                    <span>
                      뷰
                    </span>
                  </div>
                  <div className="perf-desc">
                    전체 로드 수
                    {/* <span>
                      {Number(cur_ctr_pct || 0).toFixed(2)}%
                    </span> */}
                  </div>
                </div>
                <div className="perf-card">
                  <div className="perf-icon-bg">
                    <i className="fa-regular fa-eye"></i>
                  </div>
                  <div className="perf-title">
                    추천 실 노출수
                    {/* <i className="fa-regular fa-circle-question"></i> */}
                    <div className="tooltip-container">
                      <HelpCircle className="tooltip-icon" size={14} />
                      <div className="tooltip-text">
                        소비자가 스크롤하여 실제 추천 영역이<br />화면에 노출된 횟수입니다.
                      </div>
                    </div>
                  </div>
                  <div className="perf-value num-font">
                    {this.formatNumber(cur_imp)}
                    <span>
                      건
                    </span>
                  </div>
                  <div className="perf-desc">
                    도달률
                    <span>
                      {Number(reachPct || 0).toFixed(2)}%
                    </span>
                  </div>
                </div>
                <div className="perf-card">
                  <div className="perf-icon-bg">
                    <i className="fa-solid fa-arrow-pointer" style={{"transform": "rotate(-15deg)"}}></i>
                  </div>
                  <div className="perf-title">
                    추천 클릭수
                  </div>
                  <div className="perf-value num-font">
                    {this.formatNumber(cur_click)}
                    <span>
                      건
                    </span>
                  </div>
                  <div className="perf-desc">
                    클릭 전환율
                    <span>
                      {Number(cur_ctr_pct || 0).toFixed(2)}%
                    </span>
                  </div>
                </div>
                <div className="perf-card">
                  <div className="perf-icon-bg">
                    <i className="fa-solid fa-bag-shopping"></i>
                  </div>
                  <div className="perf-title">
                    추천 구매 건수
                  </div>
                  <div className="perf-value num-font">
                    {Number(cur_click) === 0 ? 0 : this.formatNumber(cur_order)}
                    <span>
                      건
                    </span>
                  </div>
                  <div className="perf-desc">
                    구매 전환율
                    <span>
                      {Number(cur_click) === 0 ? 0 : Number(cur_cvr_pct || 0).toFixed(2)}%
                    </span>
                  </div>
                </div>
                <div className="perf-card">
                  <div className="perf-icon-bg">
                    <i className="fa-solid fa-won-sign"></i>
                  </div>
                  <div className="perf-title">
                    추천 기여 매출액
                  </div>
                  <div className="perf-value num-font active">
                    ₩ {Number(cur_click) === 0 ? 0 : this.formatNumber(cur_rev)}
                  </div>
                  <div className="perf-desc">
                    <div className={"trend-badge" + (revChg.status === 'up' ? " status-up" : revChg.status === 'down' ? " status-down" : " status-neutral")}>
                      {revChg.status === 'up' && <span className="num-font"><TrendingUp size={12} className="mr-1" /> {(revChg.rate || 0).toFixed(2)}%</span>}
                      {revChg.status === 'down' && <span className="num-font"><TrendingDown size={12} className="mr-1" /> {Math.abs(revChg.rate || 0).toFixed(2)}%</span>}
                      {revChg.status === 'same' && <span className="num-font"><Minus size={12} className="mr-1" /> 0.00%</span>}
                    </div>
                    직전 기간 대비
                  </div>
                </div>
                <div className="perf-card">
                  <div className="perf-icon-bg">
                    <i className="fa-solid fa-won-sign"></i>
                  </div>
                  <div className="perf-title">
                    추천 기여 매출율
                  </div>
                  <div className="perf-value num-font active">
                    {this.formatNumber(
                      Number(total_order_amount) === 0 || Number(cur_click) === 0
                        ? 0
                        : (Number(cur_rev) / Number(total_order_amount) * 100).toFixed(2),
                      2
                    )}
                    <span>
                      %
                    </span>
                  </div>
                </div>
              </div>
              <section className="card status-banner">
                <div className="status-left">
                  <div className="radar-box">
                    <div className="radar-wave"></div>
                    <i className="fa-solid fa-satellite-dish"></i>
                  </div>
                  <div className="status-text">
                    <h2>
                      AI타겟뷰 앱 — 방문자 활동 수집 중
                      <span className="badge-success">
                        정상 작동
                      </span>
                    </h2>
                    <p>
                      실시간으로 비회원 방문자의 행동 데이터를 분석하여 추천 엔진에 완벽하게 반영하고 있습니다.
                    </p>
                  </div>
                </div>
                <div className="live-badge">
                  <div className="live-dot"></div>
                  실시간 수집 중
                </div>
              </section>
              <div className="section-title">
                <span>
                  영역별 AI 추천 현황 및 추가 도입
                </span>
              </div>
              <div className="widget-grid">
                <div className={"card widget-card" + (is_robomd_ai_detail_page_use ? " active" : "")}>
                  <div className="w-header">
                    <div className="w-icon w-icon-1">
                      <i className="fa-regular fa-file-lines"></i>
                    </div>
                  </div>
                  <div>
                    <h3 className="w-title">
                      상품 상세 (Item-Based CF)
                    </h3>
                    <p className="w-desc">
                      "이 상품을 본 고객이 함께 산 상품"을 딥러닝으로 매칭하여 추가 구매를 유도합니다.
                    </p>
                  </div>
                  <div className="w-footer">
                    <div className="w-effect">
                      <span className="e-label">
                        누적 구매 전환율
                      </span>
                      <span className="e-val num-font">
                        {robomd_detail_page_cur_cvr_pct ? this.formatNumber(robomd_detail_page_cur_cvr_pct, 2) : 0}%
                      </span>
                    </div>
                    {
                      is_robomd_ai_detail_page_use
                      ?
                      <div className="status-text-active">
                        <div className="live-dot-small"></div>
                        작동중
                      </div>
                      :
                      <button className="btn-install" onClick={() => { window.location.href = "/shop/ai/rp/algorithmList?filter_iframe_page_id=robomd_ai_detail_page"; }}>
                        설치요청
                      </button>
                    }
                  </div>
                </div>
                <div className={"card widget-card" + (is_robomd_ai_cart_page_use ? " active" : "")}>
                  <div className="w-header">
                    <div className="w-icon w-icon-2">
                      <i className="fa-solid fa-cart-shopping"></i>
                    </div>
                  </div>
                  <div>
                    <h3 className="w-title">
                      장바구니 (Cross-Sell)
                    </h3>
                    <p className="w-desc">
                      장바구니 상품과 연관성이 높은 아이템을 제안하여 동시 구매율을 높입니다.
                    </p>
                  </div>
                  <div className="w-footer">
                    <div className="w-effect">
                      <span className="e-label">
                        누적 구매 전환율
                      </span>
                      <span className="e-val num-font">
                        {robomd_cart_page_cur_cvr_pct ? this.formatNumber(robomd_cart_page_cur_cvr_pct, 2) : 0}%
                      </span>
                    </div>
                    {
                      is_robomd_ai_cart_page_use
                      ?
                      <div className="status-text-active">
                        <div className="live-dot-small"></div>
                        작동중
                      </div>
                      :
                      <button className="btn-install" onClick={() => { window.location.href = "/shop/ai/rp/algorithmList?filter_iframe_page_id=robomd_ai_cart_page"; }}>
                        설치요청
                      </button>
                    }
                  </div>
                </div>
                <div className={"card widget-card" + (is_robomd_ai_order_complete_page_use ? " active" : "")}>
                  <div className="w-header">
                    <div className="w-icon w-icon-3">
                      <i className="fa-solid fa-circle-check"></i>
                    </div>
                  </div>
                  <div>
                    <h3 className="w-title">
                      구매완료 (재구매 유도)
                    </h3>
                    <p className="w-desc">
                      결제 직후 고객의 취향을 분석해 다음 방문 시 구매할 가능성이 높은 상품을 노출합니다.
                    </p>
                  </div>
                  <div className="w-footer">
                    <div className="w-effect">
                      <span className="e-label">
                        예상 구매 전환율
                      </span>
                      <span className="e-val num-font">
                        {robomd_order_complete_page_cur_cvr_pct ? this.formatNumber(robomd_order_complete_page_cur_cvr_pct, 2) : 0}%
                      </span>
                    </div>
                    {
                      is_robomd_ai_order_complete_page_use
                      ?
                      <div className="status-text-active">
                        <div className="live-dot-small"></div>
                        작동중
                      </div>
                      :
                      <button className="btn-install" onClick={() => { window.location.href = "/shop/ai/rp/algorithmList?filter_iframe_page_id=robomd_ai_order_complete_page"; }}>
                        설치요청
                      </button>
                    }
                  </div>
                </div>
                <div className={"card widget-card" + (is_robomd_ai_main_page_use ? " active" : "")}>
                  <div className="w-header">
                    <div className="w-icon w-icon-4">
                      <i className="fa-solid fa-house"></i>
                    </div>
                  </div>
                  <div>
                    <h3 className="w-title">
                      메인 홈 (Best Seller)
                    </h3>
                    <p className="w-desc">
                      방문자의 관심 키워드와 연관된 상품을 분석하여 가장 구매 확률이 높은 상품을 보여줍니다.
                    </p>
                  </div>
                  <div className="w-footer">
                    <div className="w-effect">
                      <span className="e-label">
                        예상 구매 전환율
                      </span>
                      <span className="e-val num-font">
                        {robomd_main_page_cur_cvr_pct ? this.formatNumber(robomd_main_page_cur_cvr_pct, 2) : 0}%
                      </span>
                    </div>
                    {
                      is_robomd_ai_main_page_use
                      ?
                      <div className="status-text-active">
                        <div className="live-dot-small"></div>
                        작동중
                      </div>
                      :
                      <button className="btn-install" onClick={() => { window.location.href = "/shop/ai/rp/algorithmList?filter_iframe_page_id=robomd_ai_main_page"; }}>
                        설치요청
                      </button>
                    }
                  </div>
                </div>
              </div>
              <div className="add-new-corner" onClick={() => {window.open('/shop/qna/form?qna_type_cd=2102', '_blank');}}>
                <i className="fa-solid fa-circle-plus"></i>
                <div>
                  <span>
                    새로운 추천 코너 추가 문의하기
                  </span>
                  <p>
                    기획전, 카테고리 베스트, 팝업 등 정해진 영역 외에도 쇼핑몰 어디든 맞춤 설치가 가능합니다.
                  </p>
                </div>
              </div>
            </div>
          </main>
        </div>
      </div>
    </div>
    );
  }
}

export default AiRpMainDashboard;
